/**
 * /en/admin/structure/paragraphs_type/form_element_file/fields
 */

import { DOM_EVENTS, HTML_ELEMENTS } from "@js/constants/html-constants.es6.js"
import CLASS_NAMES from "@js/constants/css-constants.es6.js";
import Field from "@js/core/field.es6.js"
import FormElementParagraph from "@js/paragraphs/form-element-paragraph.es6.js";
import LabelFormElementParagraphField
  from "@js/fields/form-element-label-paragraph-field.es6.js";

export default class FileFormElementParagraph extends FormElementParagraph {
  get label() {
    return new LabelFormElementParagraphField({
      machineName: 'field_form_label',
      parentElement: this,
    });
  }

  get removeText() {
    return new Field({
      machineName: 'field_remove_text',
      parentElement: this,
    });
  }

  get hasValue() {
    return this.element.$()[0].files.length > 0;
  }

  constructor({ parentElement }) {
    super({
      machineName: 'form_element_file',
      parentElement,
    });
  }

  initialize() {
    const $input = this.element.$();
    $input.on(DOM_EVENTS.CHANGE, event =>
      FileFormElementParagraph.#formatUpload(event),
    );

    const $removeText = this.removeText.$();
    $removeText.on(`${DOM_EVENTS.CLICK}  ${DOM_EVENTS.KEYPRESS}`, event =>
      FileFormElementParagraph.#removeUpload(event),
    );
  }

  static #formatUpload(event) {
    const newFileNameWithFakePath = event.currentTarget.value;
    const nameWithoutFilePath = newFileNameWithFakePath.split('\\').pop();

    const fileUploadOverlaySibling = event.currentTarget.nextElementSibling;
    const fileUploadedOverlaySibling =
      fileUploadOverlaySibling.nextElementSibling;
    const fileUploadedTextHolder = fileUploadedOverlaySibling.querySelector(
      '.file-uploaded',
    );

    fileUploadedTextHolder.innerHTML = nameWithoutFilePath;

    // Hide existing overlay and file input
    fileUploadOverlaySibling.classList.add(CLASS_NAMES.HIDDEN);
    event.currentTarget.classList.add(CLASS_NAMES.HIDDEN);
    fileUploadedOverlaySibling.classList.remove(CLASS_NAMES.HIDDEN);
  }

  static #removeUpload(event) {
    const fileUploadedDiv = event.currentTarget.parentElement;
    const fileUploadDiv = fileUploadedDiv.previousElementSibling;
    const uploadParent = fileUploadedDiv.parentElement;
    const fileUploadInput = uploadParent.querySelector('.file-upload');

    fileUploadInput.value = '';
    fileUploadInput.dispatchEvent(
      new Event(DOM_EVENTS.CHANGE, { bubbles: true }),
    );

    // Hide existing overlay
    fileUploadDiv.classList.remove(CLASS_NAMES.HIDDEN);
    fileUploadInput.classList.remove(CLASS_NAMES.HIDDEN);
    fileUploadedDiv.classList.add(CLASS_NAMES.HIDDEN);
  }

  getFileAsBase64String(index = 0) {
    const $input = this.$().find(HTML_ELEMENTS.INPUT)[0];
    const file = $input.files[index];
    if (!file) {
      return null;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onerror = () => {
        reader.abort();
        reject(new Error('Unable to parse input file.'));
      };

      reader.onloadend = () => {
        const base64 = reader.result;
        const base64WithoutType = base64.split(',')[1];
        resolve(base64WithoutType);
      };

      reader.readAsDataURL(file);
    });
  }
}

(() => {
  const fileFormElement = new FileFormElementParagraph({});
  fileFormElement.onRendered(async () => {
    fileFormElement.initialize();
  });
})(Drupal);
